import React from "react";

const CornerLarge = () => (
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.3345 0.861133C16.3499 1.35181 15.9645 1.76202 15.4738 1.77735C13.2408 1.84714 9.86913 2.60853 7.08069 4.6406C4.33429 6.64204 2.11274 9.89984 2.11274 15.1111C2.11274 15.602 1.71477 16 1.22385 16C0.73293 16 0.334961 15.602 0.334961 15.1111C0.334961 9.30017 2.85415 5.52093 6.03367 3.20386C9.17115 0.917413 12.9106 0.0788066 15.4183 0.0004422C15.909 -0.0148915 16.3192 0.370453 16.3345 0.861133Z"
      fill="currentColor"
    />
  </svg>
);

export default CornerLarge;
